import { render } from "./ConfigurationPage.vue?vue&type=template&id=a51c2f70&scoped=true"
import script from "./ConfigurationPage.vue?vue&type=script&lang=js"
export * from "./ConfigurationPage.vue?vue&type=script&lang=js"

import "./ConfigurationPage.vue?vue&type=style&index=0&id=a51c2f70&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a51c2f70"]])

export default __exports__